import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/loader/loader";
import ErrorMessageModal from "../../components/errorMessageModal/errorMessageModal";
import { apiFetchWagesPayable } from "../../api/backend/admin";
import "./wagesPayable.scss";

export default function WagesPayable() {
  const { userId } = useParams();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await apiFetchWagesPayable("Pending", {
          limit: 20,
          offset: 0,
        });
        // res.data === { status, data: [ … ], meta }
        setTransactions(res.data.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load wages payable.");
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  if (loading) return <Loader />;
  if (error)
    return <ErrorMessageModal message={error} onClose={() => setError("")} />;

  return (
    <div className="wages-payable-container">
      <h2 id="contractorsAccountingTop">Wages Payable (Pending)</h2>
      {transactions.length === 0 ? (
        <p>No pending wages to display.</p>
      ) : (
        <table className="wages-payable-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Who</th>
              <th>Schedule</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx) => {
              // gather all usernames from both BA and FL events
              const baNames = (tx.brandAmbassadorEvent || []).map(
                (e) => e.userName
              );
              const flNames = (tx.fieldLeaderEvent || []).map(
                (e) => e.userName
              );
              const allNames = [...baNames, ...flNames].join(", ") || "—";

              // pull the first schedule to show date & location
              const firstEvent =
                tx.brandAmbassadorEvent?.[0] || tx.fieldLeaderEvent?.[0];
              const sched = firstEvent?.schedule;
              const schedLabel = sched
                ? `${new Date(sched.date).toLocaleDateString()} @ ${sched.location}`
                : "—";

              return (
                <tr key={tx.id}>
                  <td>{new Date(tx.date).toLocaleDateString()}</td>
                  <td>${parseFloat(tx.totalAmount).toFixed(2)}</td>
                  <td>{tx.description}</td>
                  <td>{allNames}</td>
                  <td>{schedLabel}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
